import { Restaurant } from "../../types";

type BrowserLocation = Pick<
  Location,
  "hostname" | "pathname" | "protocol" | "search"
>;

/**
 * Where a guest on a `*.prepit.*` host belongs instead, when the restaurant
 * has its own custom domain — or null when they are already in the right
 * place.
 *
 * Never redirects to the current host: a cross-listed sibling franchise can
 * swap in a restaurant whose customDomain IS this storefront (incident
 * 2026-08-29 — Mivida reroutes socialcoffeem → socialcoffee, and selecting the
 * Mivida branch on socialcoffee made the page push to itself forever).
 * Redirects to other hosts, prepit or external, are legitimate reroutes.
 */
export const getCustomDomainRedirectUrl = (
  restaurantInfo: Pick<Restaurant, "customDomain"> | null | undefined,
  location: BrowserLocation | undefined = typeof window === "undefined"
    ? undefined
    : window.location
): string | null => {
  const customDomain = restaurantInfo?.customDomain;

  if (
    !location ||
    !customDomain ||
    !location.hostname.includes(".prepit.") ||
    customDomain === location.hostname
  ) {
    return null;
  }

  return `${location.protocol}//${customDomain}${location.pathname}${location.search}`;
};
